import React from "react";
import { makeStyles } from "@mui/styles";
import { Brand, FormActionStatus } from "../../services/Types";

const useStyles = makeStyles({
  "@keyframes spinAnim": {
    "0%": {
      transform: "rotate(0)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  checkIcon: {
    color: "#53934F!important",
  },
  errorIcon: {
    color: "#D80443!important",
  },
  resetIcon: {
    animation: `$spinAnim 2s infinite ease`,
    display: "inline-block"
  }
});

const FormActionStatusIcon = ({
  status,
  brand,
  ...args
}: {
  status: FormActionStatus;
  brand?: Brand;
  [key: string]: unknown;
}) => {
  const classes = useStyles();

  let iconContent = <></>;

  switch (status) {
    case FormActionStatus.IN_PROGRESS:
      iconContent = (
        <i
          className={`${classes.resetIcon} t-reset`}
          style={{ color: brand?.actionItemColor || "#006C7D!important" }}
          data-testid="status-icon"
        ></i>
      );
      break;
    case FormActionStatus.DONE:
      iconContent = <i className={`${classes.checkIcon} t-check`} data-testid="status-icon"></i>;
      break;
    case FormActionStatus.ERROR:
      iconContent = <i className={`${classes.errorIcon} t-error`} data-testid="status-icon"></i>;
      break;
  }

  return <span {...args}>{iconContent}</span>;
};

export default FormActionStatusIcon;
